import { browserUtils } from "app/services/fetchService/browserUtils";

import { FetchResponseError, withFullResponseSymbol } from "./defaults";
import { getErrorMessage } from "./utils";

export const AUTH_NEED_REFRESH_HEADER = "sw-authneedrefresh";

let isReloading = false;

const shouldRefreshOnError = (response: Response) => {
    if (isReloading) {
        return true;
    }

    if (response.status === 401 || response.status === 403) {
        const headerValue = response.headers.get(AUTH_NEED_REFRESH_HEADER);
        if (headerValue === "true") {
            isReloading = true;
            return true;
        }
    }

    return false;
};

export const customFetch = async (...fetchParams: Parameters<typeof fetch>): Promise<Response> => {
    let response: Response;

    try {
        response = await fetch(...fetchParams);
    } catch (e) {
        throw new FetchResponseError(getErrorMessage(e), null, withFullResponseSymbol);
    }

    if (!response.ok) {
        if (shouldRefreshOnError(response)) {
            browserUtils.reloadPage();
            return response;
        }

        throw new FetchResponseError(response.statusText, response, withFullResponseSymbol);
    }

    return response;
};
